// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__18tyf","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1aJ3F"};